// FILENAME: frontend/src/components/CustomLegend.jsx
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CustomLegend = ({ data, onLegendClick }) => { // Changed prop name to onLegendClick
    if (!data || data.length === 0) {
        return null;
    }

    const handleClick = (label) => {
        if (onLegendClick) {
            onLegendClick(label); // Use the correct prop name
        }
    };

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', mt: 2, gap: 1, width: '100%' }}>
            {data.map((item) => (
                <Paper
                    key={item.label}
                    onClick={() => handleClick(item.label)}
                    data-testid={item.label === 'COOLING' ? 'summary-cooling-chip' : undefined}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 0.5,
                        cursor: 'pointer',
                        flexShrink: 0,
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        }
                    }}
                    variant="outlined"
                >
                    <Box sx={{ width: 12, height: 12, bgcolor: item.color, mr: 1, borderRadius: '2px' }} />
                    <Typography variant="caption">{`${item.label} (${item.value})`}</Typography>
                </Paper>
            ))}
        </Box>
    );
};

export default CustomLegend;
